import { Skeleton } from "antd"

const SingleLineSkeleton = () => {
  return (
    <Skeleton
      className="[&_.ant-skeleton-paragraph>li]:!h-1"
      title={false}
      paragraph={{ rows: 1, width: "100%" }}
      round
    />
  )
}

export default SingleLineSkeleton
